import React from 'react';
import { connect } from 'react-redux'

import { Table, Row, Col, Button, Dropdown, Pagination } from 'antd';
import { SettingOutlined, DownCircleOutlined, EditOutlined, CloseCircleOutlined, InfoCircleOutlined, DownloadOutlined, PrinterOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { _fmtRupiah, _tableLogActivity, _warn, getParamTable } from '../../../../lib/Helper';

class Desktop extends React.Component {
  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action
    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  width: '2%',
                }, {
                  title: 'Tanggal Transaksi',
                  dataIndex: 'tgl_transaksi',
                }, {
                  title: 'Pos Pengeluaran',
                  dataIndex: 'pos_pengeluaran_nama',
                }, {
                  title: 'Penanggung Jawab',
                  render: (a, row) => (row.tk_gelar_depan ? row.tk_gelar_depan : "") + (row.tk_nama ? row.tk_nama : "-") + (row.tk_gelar_belakang ? " " + row.tk_gelar_belakang : "")
                }, {
                  title: 'Nominal',
                  render: (a, row) => "Rp. " + _fmtRupiah(row.total_pengeluaran)
                }, {
                  title: 'Bukti Kwitansi',
                  render: (_, row) => row.bukti_pembayaran ? <a rel="noopener noreferrer" target='_blank' href={row.main_path + row.bukti_pembayaran} style={{ fontSize: 11 }} >Download <DownloadOutlined /></a> : "-",
                }, {
                  title: 'Keterangan',
                  render: (a, row) => row.keterangan ? row.keterangan : "-"
                }, {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => (!action.invoice && !action.detail && !action.update && !action.update ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.invoice ? [{
    key: 0,
    icon: <PrinterOutlined />,
    label: "Invoice",
    onClick: () => {
      _warn("topRight", "Gagal", "Maaf, fitur ini belum tersedia");
    }
  }] : []), ...(action.detail ? [{
    key: 1,
    label: <Link to={`pengeluaran/detail/${row.id}`}><InfoCircleOutlined /> Detail</Link>
  }] : []), ...(action.update ? [{
    key: 2,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : []), ...(action.delete ? [{
    key: 3,
    icon: <CloseCircleOutlined />,
    label: "Delete",
    onClick: this.props.modalDelete.bind(this, true, row)
  }] : [])]
}}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>),
                }, {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Desktop);
